export const commonEn = {
  nav: {
    story: 'Our Story',
    community: 'Community',
    transformation: 'Transformation',
    safety: 'Safety',
    blog: 'Blog',
    shop: 'Shop',
    donate: 'Support',
    volunteer: 'Volunteer',
    resources: 'Resources',
    crisisTracker: 'Crisis Tracker',
    partners: 'Partners',
    successStories: 'Success Stories',
  },
  // Navigation
  home: "Home",
  myStory: "My Story",
  community: "Community",
  shop: "Shop",
  blog: "Blog",
  
  // Common buttons
  readMore: "Read More",
  learnMore: "Learn More",
  joinNow: "Join Now",
  shopNow: "Shop Now",
  subscribe: "Subscribe",
  submit: "Submit",
  
  // Footer
  quickLinks: "Quick Links",
  contact: "Contact",
  followUs: "Follow Us",
  allRightsReserved: "All rights reserved",
  
  // Newsletter
  newsletterTitle: "Join Our Community",
  newsletterSubtitle: "Get weekly inspiration and updates delivered to your inbox",
  emailPlaceholder: "Enter your email",
  
  // Common phrases
  byAuthor: "By"
};

export default commonEn;
